import React, { Component } from 'react';
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import _isEqual from 'lodash/isEqual';

import { getTailwindColor } from '@trqk/utils';

interface Props {
    chartDivId: string;
    data: DetectionCountByChannel[];
    height: number;
}

const tertiary500 = am4core.color(getTailwindColor('tertiary-500'));
const zoomLevel = 10;
const categoryField = 'channel';
const valueField = 'detectionCount';

export class DetectionCountPerChannel extends Component<Props> {
    private chart: am4charts.XYChart | null = null;

    componentDidMount(): void {
        const { data, chartDivId } = this.props;
        const chart = am4core.create(chartDivId, am4charts.XYChart);
        const categoryAxis = chart.yAxes.push(new am4charts.CategoryAxis());
        const valueAxis = chart.xAxes.push(new am4charts.ValueAxis());
        const series = chart.series.push(new am4charts.ColumnSeries());

        chart.data = data;
        chart.fontSize = 12;
        chart.padding(20, 30, 0, 0);

        categoryAxis.dataFields.category = categoryField;
        // Ensures that every category label is shown
        categoryAxis.renderer.minGridDistance = 0.01;
        categoryAxis.renderer.labels.template.fill = tertiary500;
        categoryAxis.renderer.labels.template.maxWidth = 160;
        categoryAxis.renderer.labels.template.fullWords = false;
        categoryAxis.renderer.labels.template.align = 'left';
        categoryAxis.renderer.labels.template.truncate = true;
        categoryAxis.renderer.grid.template.disabled = true;

        valueAxis.renderer.labels.template.fill = tertiary500;

        series.columns.template.tooltipText = `[bold]{categoryY}[/]: {valueX}`;
        series.dataFields.valueX = valueField;
        series.dataFields.categoryY = categoryField;
        series.name = 'Detection Count';
        categoryAxis.maxZoomCount = zoomLevel;
        chart.zoomOutButton.disabled = true;

        this.chart = chart;
    }

    componentDidUpdate(prevProps: Props): void {
        const { data } = this.props;

        if (!_isEqual(prevProps.data, data)) {
            if (this.chart !== null) {
                this.chart.data = data;
            }
        }
    }

    componentWillUnmount(): void {
        if (this.chart) {
            this.chart.dispose();
        }
    }

    render(): JSX.Element {
        const { chartDivId, data, height } = this.props;

        // Sort of a hacky way to make sure that the chart is only as tall as it needs to be to
        // represent the data set
        const finalHeight =
            data.length === 0
                ? height
                : height * (data.length / zoomLevel) + 60;

        return (
            <div
                id={chartDivId}
                className="w-full"
                style={{ height: finalHeight }}
            />
        );
    }
}
